export default __webpack_public_path__ + "static/email-templates-apply-template-b2597c6ef75c4af8c388035791a4a1ff.mp4";